import { Disclosure, Transition } from '@headlessui/react';
import { ChevronDownIcon } from 'assets/svg';
import { ReactNode } from 'react';

type Props = {
  label: ReactNode;
  meta?: ReactNode;
  children: JSX.Element;
};

function Accordion({ label, meta, children }: Props) {
  return (
    <Disclosure as="div" className="flex flex-col">
      {({ open }) => (
        <>
          <Disclosure.Button className="w-full flex items-center justify-between gap-4 relative py-3 text-left">
            <span className="min-w-0 font-klarheit tracking-tight text-base font-bold truncate">{label}</span>
            <span className="flex shrink-0 items-center gap-3">
              {meta && <span className="text-sm text-palette-secondary-grey">{meta}</span>}
              <ChevronDownIcon className={`w-3 h-3 transition-transform ${open ? '-rotate-180' : 'rotate-0'}`} />
            </span>
          </Disclosure.Button>
          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Disclosure.Panel>{children}</Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
}

export default Accordion;
